import { createFileRoute, Link } from "@tanstack/react-router";

export const Route = createFileRoute("/unauthorized")({
  component: () => {
    return (
      <div className="min-h-screen bg-gray-100 flex flex-col justify-center items-center px-4">
        <div className="max-w-md w-full bg-white shadow-lg rounded-lg p-8 text-center">
          <div className="mb-6">
            <svg
              className="mx-auto h-16 w-16 text-yellow-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">
            Oops! You&apos;re not supposed to be here
          </h2>
          <p className="text-gray-600 mb-6">
            It looks like you don&apos;t have permission to access this page. Don&apos;t worry, it
            happens to the best of us!
          </p>
          <Link
            to="/"
            className="bg-primary text-primary-foreground px-4 py-2 rounded text-lg font-bold"
          >
            Go back home
          </Link>
        </div>
        <p className="mt-8 text-gray-500 text-sm">
          If you believe this is a mistake, please contact support.
        </p>
      </div>
    );
  },
});
